
  const { hot } = require("react-hot-loader/root")
  import Component from "/codebuild/output/src646894754/src/src/views/components/infographics-with-phases/index.tsx"

  export default hot(Component)
  